var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFolderIconV2 = function SvgFolderIconV2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 5")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup---Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Category-inside-view---subcategories-Copy-12",
    transform: "translate(-214.000000, -121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(0.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(214.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#75B753",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2618182,9 C23.3890182,9 23.5114182,9.05021739 23.6011782,9.14013043 L29.3611782,14.8792609 C29.4514182,14.9686957 29.5018182,15.0901739 29.5018182,15.2173913 L29.5018182,29.5652174 C29.5018182,30.3562609 28.8557382,31 28.0618182,31 L12.7018182,31 C11.9078982,31 11.2618182,30.3562609 11.2618182,29.5652174 L11.2618182,10.4347826 C11.2618182,9.64373913 11.9078982,9 12.7018182,9 L23.2618182,9 Z M23.0630982,9.95652174 L12.7018182,9.95652174 C12.4373382,9.95652174 12.2218182,10.1707826 12.2218182,10.4347826 L12.2218182,29.5652174 C12.2218182,29.8292174 12.4373382,30.0434783 12.7018182,30.0434783 L28.0618182,30.0434783 C28.3262982,30.0434783 28.5418182,29.8292174 28.5418182,29.5652174 L28.5418182,15.695 L23.2618182,15.6956522 C22.9968582,15.6956522 22.7818182,15.4818696 22.7818182,15.2173913 L22.7818182,10.3181226 C22.7818182,10.1451882 22.9072085,10.0006077 23.0714707,9.96495126 L23.0630982,9.95652174 Z M27.8638182,14.739 L23.7418182,10.633 L23.7418182,14.7391304 L27.8638182,14.739 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "+-copy-2",
    fontFamily: "ProximaNova-Black, Proxima Nova",
    fontSize: 18,
    fontWeight: 700,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.41,
    y: 30
  }, "+"))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolderIconV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder_icon_v2.cb3fefaa.svg";
export { ForwardRef as ReactComponent };